<template>
    <div class="panel panel-primary">
        <div class="panel-heading">
            {{ translations.header }}
        </div>
        <div class="panel-body">
            <div v-if="branch_reviews.length">
                <div v-for="(branch_review, index) in branch_reviews" class="form-group reviews-branch-item clearfix">
                    <label>
                        <span v-if="branch_review.is_admin" v-text="translations.account_manager"></span>
                        <span v-else v-text="translations.client"></span>
                        <span v-if="branch_review.created_at" v-text="`(${branch_review.created_at})`"></span>
                    </label>
                    <textarea
                            rows="5"
                            v-model="branch_review.text"
                            :name="`branch_reviews[${index}][text]`"
                            :id="branch_review.id || branch_review.hash"
                            :class="'form-control ' + (branch_review.is_admin ? 'editor' : '')"
                    ></textarea>
                    <input type="hidden"
                           :value="branch_review.id"
                           v-if="!branch_review.not_exists"
                           :name="`branch_reviews[${index}][id]`"
                    />
                    <input type="hidden"
                           :value="branch_review.is_admin"
                           :name="`branch_reviews[${index}][is_admin]`"
                    />

                    <br>
                    <!-- Control -->
                    <div class="row">
                        <div class="col-md-3">
                            <select v-if="!branch_review.is_admin"
                                    class="form-control input-sm"
                                    v-model="branch_review.status"
                                    :name="`branch_reviews[${index}][status]`"
                            >
                                <option v-for="(status_title, status_id) in statuses"
                                        :value="status_id"
                                        v-text="status_title"
                                ></option>
                            </select>
                        </div>
                        <div class="col-md-9">
                            <button type="button"
                                    @click="remove(index)"
                                    class="btn btn-xs btn-danger input-sm pull-right"
                            >{{ translations.buttons.remove }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <button @click="addReply()" type="button" class="btn btn-sm btn-success">
                    {{ translations.buttons.add }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['translations', 'statuses', 'existing_branch_reviews', 'current_route'],
        data() {
            return {
                branch_reviews: this.existing_branch_reviews
            };
        },
        mounted: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        },
        methods: {
            addReply: function () {
                let hash = `branch_reviews_${Date.now()}`;

                this.branch_reviews.push({
                    text: null,
                    hash: hash,
                    is_admin: true,
                    not_exists: true,
                });

                this.$nextTick().then(() => {
                    window.initCKEditor(hash);
                });
            },
            remove: function (index) {
                let branchReview = this.branch_reviews[index];

                if (branchReview.not_exists) {
                    return this.removeNotExisting(index);
                }

                this.removeExisting(branchReview, index);
            },
            removeNotExisting: function (index) {
                return this.branch_reviews.splice(index, 1);
            },
            removeExisting: function (branchReview, index) {
                if (confirm(this.translations.confirmation_of_deletion)) {
                    this.$http.post(`/admin/communication/branch_reviews/${branchReview.id}`, {
                        _method: 'delete'
                    }).then((function () {
                        this.removeNotExisting(index);
                    }).bind(this)).catch(() => {
                        alert(this.translations.error);
                    });
                }
            }
        }
    }
</script>
